import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {fontHeuristics} from './heuristicsDefinitions'
import {createAdaptiveHeuristic} from '../common'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const scaleFontSize = (componentStageData: ComponentStageData) => {
        const heuristicToApply = fontHeuristics.find(({predicate}) => predicate(componentStageData))!

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(scaleFontSize))
    }

    const name = 'textScale'
    return {register, name, dependencies: []}
}
